import AppContext from 'App/AppContext';
import { IPFontIcon, IPLabel } from 'baseComponents';
import { IPStack } from 'baseComponents/Stack/IPStack';
import { canUpdateTaskField, TaskFieldTypes } from 'components/Tasks/TaskAuthHelper';
import RichTextEditor from 'components/Text/RichTextEditor';
import { globalStackTokensGapExtraSmall, globalStackTokensGapMedium } from 'globalStyles';
import Task from 'models/tasks/task';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useCloseTaskDetailCallout, useIsInTaskDetailCallout } from './TaskDetailRow';
import { iconFontSize, readOnlyRowSpace } from './TaskDetailStyles';

interface ITaskDetailDescriptionProps {
  orgTask: Task;
  task: Task;
  canUpdate: boolean;
  readonly?: boolean;
  onUpdate: (newTask: Task) => void;
}

export const TaskDetailDescription = (props: ITaskDetailDescriptionProps) => {
  const isInCallout = useIsInTaskDetailCallout();
  const appContext = useContext(AppContext);
  const { t } = useTranslation(['task', 'translation']);
  //set when the editor sits in a row callout of the task detail panel
  const closeCallout = useCloseTaskDetailCallout();
  const isReadonly =
    props.readonly || !canUpdateTaskField(props.orgTask, props.canUpdate, TaskFieldTypes.Description, appContext);

  //
  // Main render
  //
  return (
    <IPStack
      horizontal
      tokens={appContext.isMobileView ? globalStackTokensGapExtraSmall : globalStackTokensGapMedium}
      verticalAlign="start"
      styles={isReadonly ? { root: { paddingBottom: readOnlyRowSpace } } : undefined}
    >
      {!isInCallout && (
        <IPStack.Item>
          {!appContext.isMobileView && <IPFontIcon iconName="TextDocument" style={iconFontSize} />}
        </IPStack.Item>
      )}
      <IPStack.Item grow styles={{ root: { minWidth: 0 } }}>
        <IPLabel>{t('task:Description.Label')}</IPLabel>
        <RichTextEditor
          html={props.task.description}
          onChange={(value: string) => {
            const copyTask = props.task.clone();
            copyTask.description = value;
            props.onUpdate(copyTask);
          }}
          placeholder={t('task:Description.Placeholder')}
          maxLength={8000}
          readOnly={isReadonly}
          maxHeight={300}
          //in a callout the editor is open at once, with room for several lines
          directEdit={closeCallout && !isReadonly ? true : undefined}
          minHeight={closeCallout ? 120 : undefined}
          onKeyDown={closeCallout ? (ev) => ev.key === 'Escape' && closeCallout() : undefined}
        />
      </IPStack.Item>
    </IPStack>
  );
};
